import { createFileRoute } from "@tanstack/react-router";
import { CancelAccountDeletionPage } from "@/modules/users/presentation/pages/CancelAccountDeletionPage";

export const Route = createFileRoute("/cancelar-exclusao")({
  component: CancelAccountDeletionPage,
});
